import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-bg",
  "use": "icon-icon-bg-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-bg\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\">\n    <path fill=\"#d62612\" d=\"M0 341.3h512V512H0z\" />\n    <path fill=\"#fff\" d=\"M0 0h512v170.7H0z\" />\n    <path fill=\"#00966e\" d=\"M0 170.7h512v170.6H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol